import script from "./LoginBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginBlock.vue?vue&type=script&setup=true&lang=js"

import "./LoginBlock.vue?vue&type=style&index=0&id=93d47e28&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93d47e28"]])

export default __exports__